module.exports = __webpack_public_path__ + "static/img/08.d35581d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/08.jpg
// module id = 6HLt
// module chunks = 1